/**
 * Recharts theme — uses MCUI tokens directly (recharts SVG attrs
 * don't resolve CSS variables, so we hard-code hex from tokens.css).
 */
export const chartTheme = {
  background: '#11141B',
  grid: '#1E2330',
  axis: '#7A8197',
  text: '#B8BDC8',
  textMuted: '#7A8197',

  brand: '#3B82F6',
  brandGlow: 'rgba(59, 130, 246, 0.35)',
  brandBg: 'rgba(59, 130, 246, 0.12)',

  ok: '#10B981',
  okBg: 'rgba(16, 185, 129, 0.12)',
  warn: '#F59E0B',
  warnBg: 'rgba(245, 158, 11, 0.12)',
  crit: '#EF4444',
  critBg: 'rgba(239, 68, 68, 0.12)',

  // Palette for distinct series (editorias, etc.)
  series: [
    '#3B82F6', // brand blue
    '#10B981', // green
    '#F59E0B', // amber
    '#EF4444', // red
    '#8B5CF6', // violet
    '#EC4899', // pink
    '#14B8A6', // teal
    '#84CC16', // lime
  ],
} as const;

export const chartTooltipStyle = {
  backgroundColor: '#181C25',
  border: '1px solid #2A2F3D',
  borderRadius: 4,
  padding: 8,
  fontSize: 12,
  fontFamily: 'JetBrains Mono, monospace',
};
